<div *ngIf="!formElement.hide" [ngClass]="rowClass">
	<!-- <div class="row"> -->
	<label [for]="formElement.name" [ngClass]="labelClass">
		{{formElement.label}}
		<span class="mandatoryColor" *ngIf="(formElement.label) && (formElement.required || formElement.showAstrisk) && !formElement.silentRequired">*</span>
	</label>
	<div [ngClass]="inputClass">
		<app-d-form-input [formGroup]="formRef" [formElements]="formElement.inputs" (change)="onChange()">
		</app-d-form-input>
	</div>
	<ng-container *ngIf="!formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div [ngClass]="inputClass">
			<ng-content></ng-content>
		</div>
	</ng-container>
	<ng-container *ngIf="formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div class="min-height-20">

		</div>
	</ng-container>

</div>
